import { ErrorResponse } from './ErrorResponse';
import { Response } from './Response';
import { ResponseStatus } from './ResponseStatus';
import { AxiosResponse } from 'axios';
import { notifications } from '../../../notifications/NotificationStore';
import { Variant } from '../../../../components/notifications/Variant';

export enum NotificationTypes {
    NO_CONNECTION = 'no-connection'
}

export class ResponseService<T, E extends ErrorResponse> {
    private response?: Response<T> | Response<E>;

    public async handleRequest(request: Promise<AxiosResponse<T | E>>): Promise<Response<T> | Response<E>> {
        try {
            this.response = new Response(await request) as Response<T>;

            return this.handleResponse();
        } catch (e) {
            if (e.response) {
                this.response = new Response<E>(e.response) as Response<E>;

                return this.handleErrorResponse();
            }
        }

        return this.makeNoResponseError() as Response<E>;
    }

    // @todo add redirect response
    private handleResponse(): Response<T> {
        notifications.removeNotificationByType(NotificationTypes.NO_CONNECTION);
        return this.response as Response<T>;
    }

    private handleErrorResponse(): Response<E> {
        if ((this.response?.getStatus() as number) >= 500) {
            notifications.addNotification({
                variant: Variant.DANGER,
                message: 'Er is iets misgegaan. Probeer het opnieuw'
            });
        }

        if (this.response?.getStatus() === ResponseStatus.NO_PERMISSIONS) {
            notifications.addNotification({
                variant: Variant.DANGER,
                message: 'U heeft niet de permissie om deze handeling te doen'
            });
        }

        return this.response as Response<E>;
    }

    private makeNoResponseError(): Response<ErrorResponse> {
        notifications.addNotification({
            variant: Variant.WARNING,
            message: 'Geen verbinding met de server mogelijk',
            once: true,
            type: NotificationTypes.NO_CONNECTION
        })

        // probably no internet connection
        return Response.make({
            message: 'No response body found'
        });
    }
}
